type Listener = (data: any) => void

const addDocumentListener = (eventName: string, listener: Listener) => {
  const eventListener = (event: Event) => {
    try {
      const ev = event as CustomEvent
      listener(ev.detail)
    } catch {
      // no-op
    }
  }

  document.addEventListener(eventName, eventListener)
}

class GameManager {
  private listeners = new Map<string, Set<Listener>>()
  private loadScriptCalled = false

  constructor() {
    addDocumentListener('set', (data: any) => {
      const action = data?.action
      if (!action) return
      const set = this.listeners.get(action)
      set?.forEach((cb) => cb(data?.data))
    })
  }

  subscribe(eventAction: string, listener: Listener) {
    if (!this.listeners.has(eventAction)) {
      this.listeners.set(eventAction, new Set())
    }
    this.listeners.get(eventAction)?.add(listener)
  }

  unsubscribe(eventAction: string, listener: Listener) {
    this.listeners.get(eventAction)?.delete(listener)
  }

  send(eventAction: string, eventData: any = null) {
    document.dispatchEvent(
      new CustomEvent('set', {
        detail: { action: eventAction, data: eventData },
      })
    )
  }

  loadScript(gameURL?: string | null) {
    if (this.loadScriptCalled || !gameURL) {
      return
    }

    this.loadScriptCalled = true
    const script = document.createElement('script')
    script.src = gameURL
    script.async = false
    document.head.appendChild(script)
  }
}

const gameManager = new GameManager()
export default gameManager
